import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import packageConfig from '../package.json';
import { PostHogProvider } from 'posthog-js/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { App } from './App';
import AppProvider from './providers/AppProvider';
import SettingsProvider from './providers/SettingsProvider';
import './css/index.css';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://4ef023b94fba4dfd9ab26e6a3f8610f3@o142627.ingest.us.sentry.io/1074117',
    // integrations: [Sentry.browserTracingIntegration()],
    release: packageConfig?.version ?? '',
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^\//, /^https:\/\/api\.spacedashboard\.com/],
  });

  posthog.init('phc_9c7D91ze1wShYC4X83jlsYBnNvqDMSaOOyeJEm418hK', {
    api_host: 'https://t.spacedashboard.com',
    defaults: '2026-05-30',
  });
}

const sharedInterval = 60000 * 10; // 10 minutes
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 0,
      gcTime: sharedInterval,
      refetchInterval: sharedInterval,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('app')!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack ?? '');
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <QueryClientProvider client={queryClient}>
        <SettingsProvider>
          <AppProvider>
            <Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
              <App />
            </Sentry.ErrorBoundary>
          </AppProvider>
        </SettingsProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
